export function isLoggedIn() {
  return !!localStorage.getItem("admintoken");
}
export function logout() {
  localStorage.removeItem("admintoken");
  localStorage.removeItem("adminuser");
}
